export function initials(username) {
    if (!['number', 'string'].includes(typeof username)) return '';

    const data = username.toString().split(' ');
    const [[firstInitial], ...rest] = data;
    const [lastInitial] = (rest || []).reverse();

    return `${firstInitial || ''}${lastInitial?.[0] || ''}`?.toUpperCase();
}

export function slugify(string) {
    return string
        .toString()
        .replace(/[äåöüÄÅÖÜß]/g, '_')
        .split(/[^\w]/)
        .filter(item => !!item)
        .join('-')
        .toLowerCase();
}

export function capitalize([first, ...rest], config) {
    return `${first.toUpperCase()}${config?.restToLower
        ? rest.join('').toLowerCase()
        : rest.join('') }`;
}

export function prepareVerificationCode(verificationCode) {
    const codeRegex = /[sS][tT]1-(\d)*/;
    const emailVerificationCodeStripped = verificationCode.replaceAll(' ', '');

    const verificationCodeFixed = emailVerificationCodeStripped.match(codeRegex)
        ? emailVerificationCodeStripped
        : `ST1-${emailVerificationCodeStripped}`;

    return verificationCodeFixed.toUpperCase();
}
